<form [formGroup]="form">
    <h1 class="main sticky-top">
        <div class="row">
            <div class="col-sm-8">Email Content Settings</div>
            <div class="col-sm-4">
                <div class="d-flex flex-row align-items-center flex-wrap justify-content-end">
                    <button type="button" uiSref="authenticated.portal" class="btn btn-info mt-2">Close</button>
                    <button type="button" (click)="submit(form)" class="btn btn-primary mt-2 ms-sm-2">Save</button>
                </div>
            </div>
        </div>
    </h1>


    <div class="content portal-settings">

        <div class="form-group col-sm-4">
            <label class="form-label" for="emailSelector"><b>Application Email</b></label>
            <select ng-model="selectedOption" class="form-select" id="emailSelector" (change)="onEmailChange()">
                    <option value="" >Select Email</option>
                    <option *ngFor="let email of emails"
                            [value]="email.EmailType">{{ email.FriendlyName }}</option>
                </select>
        </div><br/>
        <div class="form-group col-sm-8">
                <label for="emailSubject" class="form-label"><b>Subject</b></label>
                <input type="text" id="emailSubject" class="form-control"
                    formControlName="Subject" />
        </div>
        <div class="form-group col-sm-8">
            <label for="emailBody" class="form-label"><b>Body</b></label>
            <quill-editor id="emailBody" class="w-100" formControlName="Body" ></quill-editor>

        </div>
        <div class="form-group col-sm-8" *ngIf="currentEmail.RepeatContent != null">
            <label for="emailRepeatContent" class="form-label"><b>Repeating Content</b></label>
            <quill-editor id="emailRepeatContent" class="w-100" formControlName="RepeatContent"></quill-editor>

        </div>
        <button type="button" (click)="preview(form)" class="btn btn-info">Preview</button>
    </div>
</form>
